/**
 * Utilitários de formatação para o STELLARI SERVE
 */

export function formatCurrency(value) {
  if (value === null || value === undefined || isNaN(value)) {
    return "A DEFINIR";
  }
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL"
  }).format(value);
}

export function formatPriceDisplay(price, pricePending, priceLabel) {
  if (pricePending || price === null || price === undefined) {
    return priceLabel || "Preço sob confirmação";
  }
  return formatCurrency(price);
}
